import { render } from "./Section2.vue?vue&type=template&id=73ec899c"
import script from "./Section2.vue?vue&type=script&lang=js"
export * from "./Section2.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__